'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DropdownItem = DropdownItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropdownItem(props) {
    var children = props.children;

    return _react2.default.createElement("li", { role: "presentation" }, children);
}
DropdownItem.propTypes = {
    children: _propTypes2.default.node.isRequired
};
//# sourceMappingURL=DropdownItem.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Dropdown/DropdownItem.js